<template>
  <span class="tw-rounded-xl tw-w-[108px] tw-h-[32px] tw-bg-[rgba(217,217,217,0.5)] tw-blur" />
</template>

